//libs
import React, { memo } from 'react';

//components
import FooterIcon from './FooterIcon';

//styles
import { StyledFooter, ImageContainer, SvgContainer } from './styles';

//types
import { AccountFooterProps } from './types';

function AccountFooter({ footerData, isLoggedIn }: AccountFooterProps) {
  return (
    <>
      <StyledFooter>
        {!!footerData.length &&
          footerData
            .filter((icon) => icon.isEnabled && (icon?.loggedInUser ? isLoggedIn : true))
            .map((icon) => {
              return (
                <FooterIcon key={`footer-icon-${icon.key}`} text={icon.title} url={icon.action_url}>
                  {!icon?.icon_url?.length ? (
                    <SvgContainer name={icon.key} />
                  ) : (
                    <ImageContainer src={icon.icon_url} alt="icon" placeholderColor="none" />
                  )}
                </FooterIcon>
              );
            })}
      </StyledFooter>
    </>
  );
}

export default memo(AccountFooter);
